<div class="wrapper">
    <div class="outer_area d-flex align-items-center justify-content-center overflow-hidden">
        <div class="inner_area d-flex h-100 w-100 overflow-hidden">
            <div class="left_part h-100 w-50 d-flex align-items-center justify-content-center">
                <div class="content_area text-center mt-5">
                    <h4>WELCOME TO</h4>
                    <h2 class="my-3">VIDEOSTYLERR</h2>
                    <p class="mb-0">Sign in to continue access</p>
                </div>
            </div>
            <div class="right_part w-50">
                <img src="assets/images/logo.png" class="img-fluid" alt="Site_Logo">
                <form action="" class="mt-5 text-center" #user="ngForm"  novalidate (ngSubmit)="login(user)">
                    <h3 class="mb-4">USER LOGIN</h3>
                    <div class="form-group mb-4">
                        <input ngModel #email="ngModel" required  type="text" class="form-control" name="email" placeholder="Username or Email" pattern="^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$">
                        <p class="text-danger" *ngIf="!email.valid && user.submitted">
                          <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="email.errors.required">Email is required!</span>
                          <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="email.errors.pattern">Please enter a valid email address.</span>
                        </p>
                    </div>
                    <div class="form-group mb-4">
                        <input ngModel #password="ngModel" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*" required minlength="8" maxlength="50" type="password" class="form-control" name="password" placeholder="Password">
                        <p class="text-danger" *ngIf="!password.valid && user.submitted">
                          <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="password.errors.required">Password is required!</span>
                          <span class="d-block text-left mt-1 ml-1 small text-danger" *ngIf="password.errors.pattern">Minimum of 8 characters, 1 uppercase letter, 1 lowercase letter, and 1 number.</span>
                        </p>
                    </div>
                    <!-- <div class="row custom_radio_btns mb-4">
                        <div class="form-group col-sm-6 pl-0">
                            <div class="custom-control custom-radio pl-0">
                                <input type="radio" class="custom-control-input" id="remember_me" name="example" value="customEx">
                                <label class="custom-control-label" for="remember_me">Remember me</label>
                            </div>
                        </div>
                        <div class="form-group col-sm-6 pl-0 text-right">
                            <div class="custom-control custom-radio pl-0">
                                <input type="radio" class="custom-control-input" id="forgot_password" name="example" value="customEx">
                                <label class="custom-control-label" for="forgot_password">Forgot Password</label>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-group mb-5">
                        <input type="submit" class="btn login_btn" value="LOGIN">
                    </div>
                    <p>Don’t have an Account? <a href="/register">SIGN UP HERE</a></p>

                </form>
            </div>
        </div>
    </div>
</div>
